import { Component, Input, OnInit, inject } from '@angular/core';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { Prescription } from '../../../core/models/prescription.model';
import { NavigationService } from '../../../core/services/navigation.service';
import { PrescriptionsService } from '../../../core/services/prescriptions.service';
import { PrescriptionCapture } from '../../../core/models/capture-lists/prescription-capture-model';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CandidateReferenceNumberComponent } from '../candidate-reference-number/candidate-reference-number.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CaptureStatusPipe } from 'app/shared/pipes/capture-status.pipe';
import { CaptureStatusReasonPipe } from '../../pipes/capture-status-reason.pipe';

@Component({
    selector: 'app-prescription-captures',
    templateUrl: './prescription-captures.component.html',
    styleUrls: ['./prescription-captures.component.scss'],
    imports: [RouterLink,
              CandidateReferenceNumberComponent,
              MatProgressSpinner,
              DatePipe,
              CaptureStatusPipe,
              CaptureStatusReasonPipe]
})
export class PrescriptionCapturesComponent implements OnInit {
  private prescriptionsService = inject(PrescriptionsService);
  private navigationService = inject(NavigationService);
  private authService = inject(AuthenticationService);

  @Input() prescription: Prescription;
  @Input() activeCaptureId: number;

  loading = true;
  showEstimatedValue = false;
  baseCaptureUrl = null;
  captures: PrescriptionCapture[] = [];

  ngOnInit() {
    this.showEstimatedValue = this.authService.isCaptureAdminUser;
    this.baseCaptureUrl = this.navigationService.baseShowUrl('captures');
    this.loadCaptures();
  }

  private loadCaptures() {
    this.prescriptionsService.getCaptures(this.prescription).subscribe((captures: PrescriptionCapture[]) => {
      this.loading = false;
      this.captures = captures.sort((a: PrescriptionCapture, b: PrescriptionCapture) =>
        a.id === this.activeCaptureId ? -1 : b.id === this.activeCaptureId ? 1 : 0);
    });
  }
}
